import { ICompanyCourseView } from '../course';
import { ScormMode } from './companyConfigurationTypes';
import { IOnboardingStep } from './onboardingStepTypes';
import { IPartnerDisplay } from './partnerTypes';

export enum CompanySize {
  ONE_TO_TEN = '1-10',
  ELEVEN_TO_FIFTY = '11-50',
  FIFTY_ONE_TO_TWO_FIFTY = '51-250',
  TWO_FIFTY_ONE_TO_ONE_THOUSAND = '251-1000',
  ONE_THOUSAND_PLUS = '1000+',
}

export enum MarketingCompanySize {
  ONE_TO_FORTY_NINE = '1-49',
  FIFTY_TO_NINETY_NINE = '50-99',
  ONE_HUNDRED_TO_TWO_FORTY_NINE = '100-249',
  TWO_FIFTY_TO_FOUR_NINETY_NINE = '250-499',
  FIVE_HUNDRED_TO_NINE_NINETY_NINE = '500-999',
  ONE_THOUSAND_TO_FOUR_THOUSAND_NINE_HUNDRED_NINETY_NINE = '1,000-4,999',
  FIVE_THOUSAND_TO_NINE_THOUSAND_NINE_HUNDRED_NINETY_NINE = '5,000-9,999',
  TEN_THOUSAND_PLUS = '10,000+',
}

export enum Organization {
  ETHENA = 'ETHENA',
  LIFE_LABS = 'LIFE_LABS',
  SEQUOIA_ONE = 'SEQUOIA_ONE',
}

export interface ICompany {
  addressCity: string;
  addressLine1: string;
  addressLine2: string;
  addressState: string;
  addressZip: string;
  billingMethod: string;
  cardholderName: string;
  contactEmail?: string;
  contactPhone?: string;
  createdBy: number;
  customCategoryLabel?: string;
  customReminderEmailPrefix?: string;
  defaultPaymentMethod?: string;
  howDidYouHear?: string;
  id: number;
  industry: string;
  isDisabled: boolean;
  isTest: boolean;
  name: string;
  partnerId?: number;
  trainingReminderCadence: string;
  teamInsightsReminderCadence: string;
  reminderDayOfWeek: number;
  signupCompletedAt?: string;
  signupStartedAt: string;
  size: CompanySize;
  stripeId?: string;
  stripeTaxRateId?: string;
  updatedBy: number;
}

export interface ICompanyView extends ICompany {
  companyCourses: ICompanyCourseView[];
  companyUrlAlias: string;
  configurations: {
    allowUsersWithoutEmails: boolean;
    customCourseContactEmail?: string;
    disableNotifications: boolean;
    isActivityReportEnabled: boolean;
    isAnalyticsEnabled: boolean;
    isCustomCourseImportEnabled: boolean;
    isDemoAccount: boolean;
    isEnterpriseAccount?: boolean;
    isMisconductReportingCaseManagementEnabled: boolean;
    isMisconductReportingEnabled: boolean;
    isMultipleEthenaCampaignsPerCourseEnabled: boolean;
    isPhishingCampaignsEnabled: boolean;
    languagePickerOptions: string[];
    misconductReportingAdminNotePeopleReported?: string;
    misconductReportingAdminNoteProcess?: string;
    misconductReportingAdminNoteTimeline?: string;
    scormHideEthenaReferences: boolean;
    scormMode: ScormMode;
    ssoConnection?: string;
    ssoKioskEnabled?: boolean;
  };
  hasStartedTraining: boolean;
  onboardingSteps?: IOnboardingStep[];
  organization: Organization;
  partner?: IPartnerDisplay;
}
